<!-- title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div
      class="tw-mt-[10px] tw-rounded-[10px] tw-items-center alert alert-primary rounded tw-p-5 tw-mb-5"
    >
      <span> {{ "messages.isValidNumber" | translate }} </span>
    </div>

    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex-center tw-flex-col">
          <!-- mobile -->
          <form-field
            [(value)]="mobile"
            (input)="isValid = null"
            class="tw-w-full"
            [control]="form?.get('mobile')"
            label="common.mobile"
            type="tel"
            [isMobileField]="true"
            [maxLength]="12"
          >
          </form-field>
        </div>
        <div
          *ngIf="isValid != null"
          [class]="isValid ? 'bg-light-success' : 'bg-light-danger'"
          class="tw-mt-[10px] fw-bold tw-rounded-[10px] tw-flex tw-items-center rounded p-5"
        >
          <i
            [class]="getIsValidMobileIcon(isValid)"
            class="mdi tw-pl-2 mdi-20px"
          ></i>
          <span *ngIf="isValid"> {{ "common.validMobile" | translate }}</span>
          <span *ngIf="!isValid">
            {{ "common.notValidMobile" | translate }}</span
          >
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [customTitle]="'common.check'"
      [btnType]="'submit'"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
